export const appSettings = {
  apiImagenes: 'http://192.168.1.5:4884'
};
